import useReceiptDetails from 'src/hooks/useReceiptDetails';

const ReceiptNumber = () => {
  const { receiptData } = useReceiptDetails();
  return (
    <div
      className="p-1 flex flex-col gap-1 text-[13px]"
      title={receiptData?.receivingReceiptId.toString()}
    >
      <p className="font-bold">Receipt # </p>
      <p className="pl-1">{receiptData?.receivingReceiptId}</p>
    </div>
  );
};

export default ReceiptNumber;
